module.exports = __webpack_public_path__ + "img/nkechi.c4aa6a31.png";